import { Money } from "./bulk-purchase/bulk-purchase";

export interface SavedCard {
	id: string;
	panNumber: string;
	cardType: string;
}

export interface GetCustomerSavedCardsResult {
	savedCards: SavedCard[];
}

export interface AddNewCardResponse {
	url: string;
	recurringContextId: string;
}

export interface DateRangeParams {
	from: string; // ISO date-time string
	to: string; // ISO date-time string
	isMonthly: boolean;
}

export interface EnergyAccountResponse {
	accountNo: string;
	consumption: number;
	averageConsumption: number;
	consumptionInNGN: number;
}

export interface ConsumptionData {
	consumption: number;
	date: string; // ISO date-time string
}

export interface MeterConsumptionGraphResponse {
	data: ConsumptionData[];
}

export interface BillPaymentProcess {
	repaymentLoanProcessId: string; // UUID
	startDate: string; // ISO date-time string
	totalAmount: Money;
	installmentAmount: Money;
	paidFor: Money;
	penalty: Money;
	isActive: boolean;
	isDeleted: boolean;
}

export interface RepaymentLoanResponse {
	isDeleted: boolean;
	recurringContextId: string; // UUID
	customerId: string; // UUID
	orderId: string; // UUID
	isAdminIntervention: boolean;
	amount: Money;
	remaining: Money;
	status: string;
	paymentCompletedAt: string; // ISO date-time string
	startDate: string; // ISO date-time string
	numberOfBills: number;
	penaltyPercentage: number;
	billPaymentProcesses: BillPaymentProcess[];
}

export interface VerifyMeterNumberPayload {
	MeterNumber: string;
	UtilityId: string;
}

export interface VerifyPostpaidMeterResponse extends VerifyPrepaidMeterResponse {
	// accountName: string;
	outstandingBalance: number;
	address: string;
	// district: string;
}

export interface VerifyPrepaidMeterResponse {
	status: string;
	accountName: string;
	district: string;
	minimumVendAmount: number;
	minimumBorrowAmount: number;
	maximumBorrowAmount: number;
	outstandingDebt: number;
	showPreferRemoteTokenLoadOption: boolean;
}

export interface VerifyCustomerResponse {
	status: string;
	accountName: string;
	district: string;
	minimumVendAmount: number;
	minimumBorrowAmount: number;
	maximumBorrowAmount: number;
	outstandingDebt: number;
	showPreferRemoteTokenLoadOption: boolean;
    outstandingBalance?: number;
	address?: string;
}

export interface BorrowTokenPayload {
	meterNumber: string;
	pin: string;
	amount: number;
}

export interface BorrowTokenResponse {
	vendingDetailsId: string;
	reference: string;
}

export interface ChargeFee {
	clientFee: {
		currency: string;
		amount: number;
	};
}

export enum VendingPaymentOptions {
	"Card",
	"Wallet"
}

export interface InitiateVendingPayload {
	utilityId: string;
	meterNumber: string;
	amount: number;
	pin: string;
	remoteTokenLoading?: boolean | null;
}

export interface InitiateVendingCardPayload extends InitiateVendingPayload {
	returnUrl: string;
	paymentTypes: Array<string>;
}

export interface InitiatePostpaidNotificationCardPayload {
	billingDashNotificationId: string;
	pin: string;
	returnUrl: string;
	paymentTypes: Array<string>;
	remoteTokenLoading?: boolean | null;
}

export interface InitiatePostpaidNotificationWalletPayload {
	billingDashNotificationId: string;
	pin: string;
	remoteTokenLoading?: boolean | null;
}

// Matches backend FriendRequestNotificationChannel (Email = 0, Sms = 1, Both = 2)
export enum FriendRequestNotificationChannel {
	Email = 0,
	Sms = 1,
	Both = 2,
}

export interface InitiateFriendPaymentRequestPayload {
	utilityId: string;
	meterNumber: string;
	amount: number;
	returnUrl: string;
	paymentTypes: Array<string>;
	recipientEmail: string;
	recipientPhoneNumber?: string;
	note?: string;
	notificationChannel: FriendRequestNotificationChannel;
}

export interface InitiateFriendPaymentRequestResponse {
	requestLink: string;
}

export interface FriendPaymentRequestStatusResult {
	status: number;
	paymentLink?: string;
	amount: Money;
	expiresAt: string;
}

export interface GuestBillResponse {
	customerName: string;
	accountNumber: string;
	address: string;
	amountPayable: number;
	outstandingBalance: number;
	period: string;
}

export interface InitiateGuestPayBillPayload {
	token: string;
	utilityName: string;
	email: string;
	phoneNumber?: string;
	amount: number;
	returnUrl: string;
	paymentTypes: Array<string>;
}

export interface InitiateGuestPayBillResponse {
	paymentUrl: string;
	guestCustomerDetailsId: string;
}

export interface ValidatePaymentResponse {
  reference: string;
  status: VendingStatus;
}

export enum VendingStatus {
  UNKNOWN = 0,
  IN_PROGRESS = 1,
  COMPLETED = 2,
  FAILED = 3,
  FAILED_WITH_REFUND = 4,
}
